import styled from 'styled-components'
import SegmentedControl from 'ui/src/components/controls/segmented-control'
import TextInput from 'ui/src/components/controls/text-input'

export const Categories = styled(SegmentedControl)`
    min-width: 0;
    width: 100%;
`

export const Input = styled(TextInput)`
    flex-shrink: 0;
    margin-right: 15px;
    width: 265px;
`
